/**
 * Copyright (c) Microsoft Corporation
 * All rights reserved. See License.txt in the project root for license information.
 * IScrollEventManager contentModule Interface Properties
 * THIS FILE IS AUTO-GENERATED - MANUAL MODIFICATIONS WILL BE LOST
 */

import * as Msdyn365 from '@msdyn365-commerce/core';

export interface IScrollEventManagerConfig extends Msdyn365.IModuleConfig {
    topOffset?: number;
    bottomOffset?: number;
    events?: IEventsData[];
}

export const enum EventsPosition {
    onScreen = 'onScreen',
    onScreenAbove = 'onScreenAbove',
    onScreenBelow = 'onScreenBelow',
    offScreen = 'offScreen',
    offScreenAbove = 'offScreenAbove',
    offScreenBelow = 'offScreenBelow'
}

export const enum EventsAction {
    add = 'add',
    remove = 'remove'
}

export interface IEventsData {
    position: EventsPosition;
    triggerClass: string;
    offset?: number;
    targetClass: string;
    action: EventsAction;
    actionClass: string;
    bidirectional?: boolean;
}

export interface IScrollEventManagerProps<T> extends Msdyn365.IModule<T> {
    config: IScrollEventManagerConfig;
}
